__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-05-25-1779712047-stable-dev/";